// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

// Import utilities
const {
	isDefined,
	isEmpty
} = _uo.utility;

import Field from './index.js';

class FieldsGroup {
	// eslint-disable-next-line no-unused-vars
	constructor( attributes, createDOMelements = true, customValidationFunction = null ) {
		// Save attributes
		this.setAttributes( attributes );

		// Create fields
		this.createFields();
	}

	/**
	 * Sets attributes. It adds properties like hasValue, hasPlaceholder, etc, automatically
	 *
	 * @param {Object} attributes The field attributes
	 * @return {undefined}
	 */
	setAttributes( attributes ) {
		// Has label
		if ( ! isDefined( attributes.hasLabel ) ) {
			if ( ! isEmpty( attributes.label ) ) {
				attributes.hasLabel = true;
			} else {
				attributes.hasLabel = false;
			}
		}

		// Has description
		if ( ! isDefined( attributes.hasDescription ) ) {
			if ( ! isEmpty( attributes.description ) ) {
				attributes.hasDescription = true;
			} else {
				attributes.hasDescription = false;
			}
		}

		this.attributes = attributes;
	}

	/**
	 * Create instances of Field
	 *
	 * @since  2.0
	 * @return undefined
	 */

	createFields() {
		// Replace fields data with Field instances
		this.fields = this.attributes.fields.map( ( fieldData ) => {
			// Create Field
			return new Field( fieldData.fieldType, fieldData );
		} );
	}

	/**
	 * Create a jQuery DOM element with the field
	 *
	 * @since 0.3
	 */

	createFormElement() {
		// Create response object
		let response = null;

		// Create container
		const $container = $( `<div class="form-group"></div>` );

		// Check if it has a label
		if ( this.attributes.hasLabel ) {
			// Create label
			const $label = $( `<div class="form-group__label">${ this.attributes.label }</div>` );

			// Append label
			$container.append( $label );
		}

		// Create form group. We're going to add the fields here
		const $formGroup = $( `<div class="form-group__fields"></div>` );
		// Iterate fields
		this.fields.forEach( ( field ) => {
			// Create form element
			const $fieldElement = field.createFormElement();

			// Append form element
			$formGroup.append( $fieldElement );
		} );
		// Append fields
		$container.append( $formGroup );

		// Check if it has a description
		if ( this.attributes.hasLabel ) {
			// Create description
			const $description = $( `<div class="form-group__description">${ this.attributes.description }</div>` );

			// Append description
			$container.append( $description );
		}

		// Save form element
		this.formElement = $container;
		response = $container;

		// Return form element
		return response;
	}

	/**
	 * Get value
	 *
	 * @since  2.0
	 * @return {object} Object where the key is the field ID and the value is the field's value
	 */

	getValue() {
		// Create object where we're going to save the values
		const fieldsValue = {};

		// Iterate fields
		this.fields.forEach( ( field ) => {
			// Add the field value
			fieldsValue[ field.getFieldID() ] = field.getValue();
		} );

		// Return validation object
		return fieldsValue;
	}

	/**
	 * Get form element
	 *
	 * @since 2.0
	 * @return {object} jQuery object of the field's container
	 */

	getFormElement() {
		return this.formElement;
	}

	/**
	 * Get attributes
	 *
	 * @since 2.0
	 * @return {object} Field attributes
	 */

	getAttributes() {
		return this.attributes;
	}

	/**
	 * Validate the fields
	 *
	 * @since 2.0
	 * @param {boolean} renderError - TRUE if you want to render the field errors, FALSE if you only want to return the response object
	 * @return {object} Object where the key is the field ID and the value is a validateField object
	 */

	validate( renderError = true ) {
		// Create validation object
		const validationObject = {
			isValid: true,
			message: '',
		};

		// Iterate fields
		this.fields.forEach( ( field ) => {
			// Validate and add response to the validation object
			validationObject[ field.getFieldID() ] = field.validate( renderError );

			// Update main validation
			validationObject.isValid = validationObject.isValid && validationObject[ field.getFieldID() ].isValid;
		} );

		// Return validation object
		return validationObject;
	}
}

export default FieldsGroup;
